import prop from 'vue-strict-prop'
import { extendFrom } from 'vue-tsx-support'

import Modal from '@/components/semantic-ui/Modal'

export default extendFrom(Modal).create({
	name: 'ConfirmModal',
	props: {
		confirmClass: prop(String).optional,
		confirmText: prop(String).default('Yes'),
		declineClass: prop(String).optional,
		declineText: prop(String).default('No'),
		header: prop(String).required,
	},
	render() {
		return (
			<div class="ui tiny modal">
				<div class="header">
					{this.header}
				</div>
				<div class="content">
					{this.$slots.default}
				</div>
				<div class="actions">
					<div class={['ui cancel button', this.declineClass]}>
						{this.declineText}
					</div>
					<div class={['ui approve button', this.confirmClass]}>
						{this.confirmText}
					</div>
				</div>
			</div>
		)
	},
})
